// Shared helpers for "which term is enrolling for this batch" + date formatting.
export const fmtShort = (d) => {
  if (!d) return "";
  const dt = new Date(d);
  return isNaN(dt) ? d : dt.toLocaleDateString("en-AU", { day: "numeric", month: "short" });
};

export const pickCurrentAndNextTerm = (terms) => {
  const today = new Date().toISOString().slice(0, 10);
  const sorted = (terms || []).filter(t => t.active !== false).sort((a, b) => (a.start_date || "").localeCompare(b.start_date || ""));
  return {
    current: sorted.find(t => (t.start_date || "") <= today && today <= (t.end_date || "9999-12-31")) || null,
    next: sorted.find(t => (t.start_date || "") > today) || null,
  };
};

// Enrolling term for a batch = current term if it has class rows for the batch, else the earliest
// upcoming term that does. Returns { term, sessions, classes, first, last } or null.
export const enrolInfo = (batchId, sessions, terms) => {
  const today = new Date().toISOString().slice(0, 10);
  const mine = (sessions || []).filter(s => s.batch_id === batchId && s.active !== false);
  const has = (t) => mine.some(s => s.term_id === t.id);
  const { current } = pickCurrentAndNextTerm(terms);
  const term = (current && has(current)) ? current
    : (terms || []).filter(t => t.active !== false && (t.end_date || "9999") >= today && has(t))
        .sort((a, b) => (a.start_date || "").localeCompare(b.start_date || ""))[0] || null;
  if (!term) return null;
  const rows = mine.filter(s => s.term_id === term.id);
  const firsts = rows.map(s => s.schedule?.first_class).filter(Boolean).sort();
  const lasts = rows.map(s => s.schedule?.last_class).filter(Boolean).sort();
  const classes = rows[0]?.schedule?.classes_count || term.classes_count || null;
  return { term, sessions: rows, classes, first: firsts[0] || term.start_date, last: lasts[lasts.length - 1] || term.end_date };
};

export const enrolLine = (info) => info
  ? [info.term.name, info.classes ? `${info.classes} classes` : null, info.first ? `starts ${fmtShort(info.first)}` : null, info.last ? `ends ${fmtShort(info.last)}` : null].filter(Boolean).join(" · ")
  : "";

// "19:00" -> "7:00 PM" (times are stored as Melbourne/AEST local wall-clock).
export const fmtTime = (t) => {
  if (!t) return "";
  const m = String(t).trim().match(/^(\d{1,2}):(\d{2})/);
  if (!m) return String(t);
  const h = Number(m[1]), mm = m[2];
  if (h > 23) return String(t);
  return `${h % 12 || 12}:${mm} ${h < 12 ? "AM" : "PM"}`;
};
export const fmtRange = (a, b) => (b ? `${fmtTime(a)} – ${fmtTime(b)}` : fmtTime(a));

// Crew training days: supports legacy single `day` and new `days` array → "Saturdays & Sundays".
export const crewDayList = (c) => (Array.isArray(c?.days) && c.days.length ? c.days : c?.day ? [c.day] : []);
export const crewDays = (c) => {
  const d = crewDayList(c).map(x => `${x}s`);
  return d.length ? (d.length === 1 ? d[0] : d.slice(0, -1).join(", ") + " & " + d[d.length - 1]) : "";
};
